import React from 'react';
import { Article, Brand, Cta, Feature, Navbar } from './Components';
import {
  Blog,
  Possibility,
  About,
  Projects,
  Header,
  Footer,
} from './Containers';
import './app.css';
import { Routes, Route } from 'react-router-dom';
import Personal from './Components/personal area/Personal';
const App = () => {
  return (
    <div className="App">
      <div className="gradient__bg">
        <Navbar />
        <Header />
      </div>
      <Brand />
      <Projects />
      <About />
      <Footer />
    </div>
  );
};

export default App;
